module.exports = __webpack_public_path__ + "templates.sms-messenger-checkbox-af60508c.html";